import { useState } from 'react';

function useInput<T>(
  initialValue: string,
) {
  const [value, setValue] = useState(initialValue);

  return {
    onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      setValue(event.currentTarget.value);
    },
    reset: (value?: string) => setValue(value || ''),
    setValue,
    value
  }
}

export default useInput;
